export default {
  __name: 'ProductsGridGraphql',
  props: {
  selectedCards: {
    type: Array,
    default: () => [],
  },
  isAdviceBlock: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const AdviceCardGraphQL = () => import('~/components/Molecules/AdviceCardGraphQL.vue');
const RecipeCardGraphQL = () => import('~/components/Molecules/RecipeCardGraphQL.vue');



return { __sfc: true,AdviceCardGraphQL, RecipeCardGraphQL, props }
}

}